import BaseListStore, { DEFAULT_LIMIT, DEFAULT_PAGE_NUMBER } from 'stores/BaseListStore';
import ExtensionResponseQueueStore from 'stores/extensionResponseQueue/ExtensionResponseQueueStore';
import {
    buildOptions,
    EntityName,
    getCount,
    getDetailsForCorrectPagination,
    getPage
} from 'stores/_services/dataService';
import { action, makeObservable, runInAction } from 'mobx';
import { buildCsvDownloadUrl } from 'stores/_services/downloadService';
import log from 'services/helpers/log';
import { getConditions } from 'stores/_services/filterService';
import { IGetDataParams } from '../../types';

const SEARCH_FIELDS = ['filename', 'extensionName', 'username', 'hostname', 'ip'];

export default class extensionResponseQueueListStore extends BaseListStore<ExtensionResponseQueueStore> {
    constructor() {
        super({
            itemStore: ExtensionResponseQueueStore
        });

        makeObservable(this, {
            getExtensionResponseQueueList: action
        });
    }

    async getExtensionResponseQueueList(args: any, pageNumber = DEFAULT_PAGE_NUMBER, pageSize = DEFAULT_LIMIT): Promise<void> {
        const shouldReset = this._updateListState(args);
        const conditionResponse = getConditions(this.filter);
        const conditions = { ...conditionResponse, status: { neq: 'completed' } };

        const options = {
            filter: {
                order: this.sort,
                limit: pageSize,
                skip: (pageNumber - 1) * pageSize,
                searchFields: SEARCH_FIELDS,
                where: conditions
            }
        };

        const { data } = await getPage(EntityName.EXTENSION_RESPONSE_QUEUE_DETAILS, options);
        const totalCount = await getCount(EntityName.EXTENSION_RESPONSE_QUEUE_DETAILS, { where: conditions, searchFields: SEARCH_FIELDS });

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data, this.skip);
        this._updateCount(data);

        runInAction(() => {
            this.count = data.length;
            this.totalCount = totalCount;
            this.page = pageNumber;
            this.pageSize = pageSize;
        });
    }

    async getExtensionResponseQueuesForCorrectPagination(args: IGetDataParams = {}): Promise<void> {
        const { filter, sortBy, sortDirection, pageSize, page } = args;

        const params = {
            filter: filter || this.filter,
            sortBy: sortBy || this.sortBy,
            sortDirection: sortDirection || this.sortDirection,
            pageSize: pageSize || this.pageSize,
            page: page || this.page,
            searchFields: SEARCH_FIELDS
        };

        const { data, totalCount } = await getDetailsForCorrectPagination<ExtensionResponseQueueStore>({ params, entityName: EntityName.EXTENSION_RESPONSE_QUEUE_DETAILS });

        this.updateStateForCorrectPagination<ExtensionResponseQueueStore>({ args, data, totalCount });
    }

    public async exportToCsv(): Promise<void> {
        const conditionResponse = getConditions(this.filter);
        const conditions = { ...conditionResponse, status: 'created' };

        const options = {
            filter: {
                searchFields: SEARCH_FIELDS,
                where: conditions
            }
        };

        const query = buildOptions(options);

        try {
            window.location.href = await buildCsvDownloadUrl(EntityName.EXTENSION_RESPONSE_QUEUE_DETAILS, query);
        } catch (e) {
            log.error(e as Error);
        }
    }
}
